import errors from '../constants.json';

const getErrorMessage = (errorType) => {
  const error = errors.errors.find(error => error.errorType === errorType);
  return error ? error.message : '';
};
export default getErrorMessage;